export default __webpack_public_path__ + "css/App.css";